module.exports = __webpack_public_path__ + "img/emblem_5.ac31cf57.svg";